window.Ajaxinate = function (options) {
  var container = document.querySelector(options.container);
  var pagination = document.querySelector(options.pagination);
  var loading = document.querySelector(options.loading);
  var isLoading = false;

  function getNextPageUrl() {
    if (!pagination) return null;
    var link = pagination.querySelector('a');
    return link ? link.getAttribute('href') : null;
  }

  function loadNextPage() {
    if (isLoading) return;
    var nextPage = getNextPageUrl();
    if (!nextPage) return;

    isLoading = true;
    if (loading) loading.style.display = 'block';

    fetch(nextPage, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
    .then(res => res.text())
    .then(data => {
      var parser = new DOMParser();
      var doc = parser.parseFromString(data, 'text/html');

      var newItems = doc.querySelectorAll(options.container + ' .grid__item');
      newItems.forEach(item => container.appendChild(item));

      var newPagination = doc.querySelector(options.pagination);
      if (newPagination && newPagination.innerHTML.trim() !== "") {
        pagination.innerHTML = newPagination.innerHTML;
      } else {
        pagination.remove();
      }

      if (loading) loading.style.display = 'none';
      isLoading = false;
    });
  }

  window.addEventListener('scroll', function () {
    var scrollPosition = window.innerHeight + window.scrollY;
    var bottom = document.body.offsetHeight - 200;

    if (scrollPosition >= bottom && !isLoading) {
      loadNextPage();
    }
  });
};